import { z } from 'zod';

/**
 * Request payload schema for attaching a file to a call-off.
 * The `fileId` field is sent as `file_id` by the kyClient's case converter.
 */
export const zodAttachCallOffAttachmentPayloadSchema = z.object({
  fileId: z.uuid(),
  fileMime: z.string().trim().min(1),
  fileName: z.string().trim().min(1),
});

export const zodAttachCallOffAttachmentEndpointSchema = z.tuple([
  z.literal('calloffs'),
  z.uuid(),
  z.literal('attachments'),
]);
